import { useContext, useEffect } from "react";
import hash from "object-hash";
import "./Filters.scss";

import {
  EntitiesContext,
  EntitiesContextProps,
} from "../../../../Contexts/EntitiesContext";
import { Checkbox } from "../../../../Components/Checkbox";
import { DateFilterEnum } from "../../../../types/DateFilterEnum";
import useResponsive from "../../../../hooks/useResponsive";
import { Input } from "../../../../Components/Input";
import { Button } from "../../../../Components/Button";

const Filters = ({
  orderFilter,
  setOrderFilter,
  onDownloadReport,
  reportLoading,
}: any) => {
  const { isDesktopOrLaptop } = useResponsive();

  const { entities, refreshEntity }: EntitiesContextProps =
    useContext<any>(EntitiesContext);

  useEffect(() => {
    refreshEntity("status");
  }, []);

  const isCheckedStatus = (value: any) => orderFilter.checkedStatus.indexOf(value) !== -1;
  const onChangeStatus = (value: number) => {
    if (isCheckedStatus(value)) {
      setOrderFilter({
        ...orderFilter,
        checkedStatus: orderFilter.checkedStatus.filter((item: any) => item !== value)
      });
    } else {
      setOrderFilter({
        ...orderFilter,
        checkedStatus: [...orderFilter.checkedStatus, value]
      });
    }
  };

  const isCheckedDate = (value: any) => orderFilter.checkedDate === value;
  const onChangeDate = (value: DateFilterEnum) => {
    setOrderFilter({
      ...orderFilter,
      checkedDate: Number(value)
    });
  };

  const dateFilters = [
    { id: DateFilterEnum.HOY, text: "Hoy" },
    { id: DateFilterEnum.AYER, text: "Desde ayer" },
    { id: DateFilterEnum.SEMANA, text: "Últimos 7 dias" },
    { id: DateFilterEnum.TODOS, text: "Todos" },
  ];

  const onChangeTrackingCode = (tracking_code: string) => {
    setOrderFilter({ ...orderFilter, tracking_code });
  };

  const onChangeName = (name: string) => {
    setOrderFilter({ ...orderFilter, name });
  };

  return (
    <div className={isDesktopOrLaptop ? "filter-section-desktop" : "filter-section-mobile"}>
      {/* Primera fila - Solo checkboxes de estado */}
      <div className="status-row">
        <div className="status-checkboxes">
          {entities.status.map((status: any) => (
            <div className="checkbox-item" key={hash(status)}>
              <Checkbox
                text={status.name}
                value={status.id}
                checked={isCheckedStatus(status.id)}
                onChange={onChangeStatus}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Segunda fila - Filtros y botón */}
      <div className="filters-action-row">
        <div className="filters-group">
          <div className="date-selector">
            <label>Filtrar por fecha:</label>
            <select
              value={orderFilter.checkedDate}
              onChange={(e) => onChangeDate(Number(e.target.value))}
            >
              {dateFilters.map((date) => (
                <option key={date.id} value={date.id}>
                  {date.text}
                </option>
              ))}
            </select>
          </div>

          <div className="input-group">
            <Input 
              onChange={onChangeTrackingCode} 
              value={orderFilter.tracking_code} 
              title="Nro. Orden" 
            />
            <Input 
              onChange={onChangeName} 
              value={orderFilter.name} 
              title="Nombre" 
            />
          </div>
        </div>
        <Button 
          onClick={onDownloadReport}
          loading={reportLoading}
          style={{ marginTop: '10px' }}
        >
          Descargar reporte
        </Button>
      </div>
    </div>
  );
}

export default Filters;